import React from "react";
import {
    PieChart,
    Pie,
    Cell,
    ResponsiveContainer,
    Tooltip
} from "recharts";

export interface DonutItem {
    id: string;           
    name: string;
    y: number;
    color: string;
    handle?: string;
    avatar?: string;
}

const DonutChart: React.FC<{
    title: string;
    data: DonutItem[];
    hoveredId?: string | null;
    tooltipRenderer?: (ctx: {
        name: string;
        value: number;
        color: string;
        handle?: string;
        avatar?: string;
        metricLabel: string;
    }) => React.ReactNode;
}> = ({ title, data, tooltipRenderer, hoveredId }) => {
    const chartData = data.map(d => ({
        id: d.id,          
        name: d.name,
        value: d.y,
        color: d.color,
        handle: d.handle,
        avatar: d.avatar
    }));

    return (
        <div style={{ width: 220, height: 220, position: "relative" }}>
            <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                    <Pie
                        data={chartData}
                        dataKey="value"
                        cx="50%"
                        cy="50%"
                        innerRadius="70%"
                        outerRadius="100%"
                        paddingAngle={1}
                        isAnimationActive
                    >
                        {chartData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} opacity={hoveredId && entry.id !== hoveredId ? 0.3 : 1} />
                        ))}
                    </Pie>

                    <Tooltip
                        wrapperStyle={{ zIndex: 9999 }}
                        content={(props: any) => {
                            if (!tooltipRenderer) return null;
                            if (!props.active || !props.payload || !props.payload.length) {
                                return null;
                            }

                            const item = props.payload[0].payload;

                            return tooltipRenderer({
                                name: item.name,
                                value: item.value,
                                color: item.color,
                                handle: item.handle,
                                avatar: item.avatar,
                                metricLabel: title
                            });
                        }}
                    />
                </PieChart>
            </ResponsiveContainer>

            {/* Center Label */}
            <div
                style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    textAlign: "center",
                    pointerEvents: "none"
                }}
            >
                <div style={{ fontSize: 12, fontWeight: 600, color: "#374151" }}>
                    {title}
                </div>
            </div>
        </div>
    );
};

export default DonutChart;
